import restaurantModalLoginInstance from '../../../modalLoginInstance'
import restaurantInstance from '../../../instance'

const closePaidBeforeOrders = (tableId, hasModalLogin = true) => {
  return (hasModalLogin ? restaurantModalLoginInstance : restaurantInstance)
    .post(`/tables/${tableId}/paidBeforeOrders/close`)
}

export default closePaidBeforeOrders
